<template>
  <base-page-component>
    <div>
      <span class="text-danger" v-for="item in validateErrors.items" v-bind:key="item.id">
        {{ `#${item.id}: ${item.msg}`}}
        <br />
      </span>
    </div>
    <div>
      <b-row>
        <b-col md="12">
          <b-card>
            <div slot="header">
              <strong>Partner: {{PartnerName}}</strong>

              <span v-if="EnterpriseData.EnterpriseId">
                <b-btn class="btn btn-success pull-right ml-2" @click="saveChanges">
                  <i title="Back" class="fa fa-floppy-o fa-lg text-white"></i> <strong class="text-white">
                    Save Changes
                  </strong>
                </b-btn>
                <b-btn class="btn btn-warning pull-right ml-2" @click="deleteEnterprise">
                  <i title="Back" class="fa fa-undo fa-lg text-white"></i> <strong class="text-white">Delete Enterprise</strong>
                </b-btn>
              </span>
              <span v-else>
                <b-btn class="btn btn-success pull-right ml-2" @click="saveChanges">
                  <i title="Back" class="fa fa-floppy-o fa-lg text-white"></i> <strong class="text-white">
                    Create Enterprise
                  </strong>
                </b-btn>
              </span>
            </div>

            <div id="divAccount">
              <b-row>
                <b-col lg="12">
                  <b-form-input v-model="EnterpriseName" placeholder="Enter enterprise name" class="my-1"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <b-card>
                    <div class="row" slot="header">
                      <b-col class="col-sm-8"><strong>List of Available Accounts</strong></b-col>
                      <b-col class="col-sm-4" style="height:34px">
                        <!-- this does nothing but set height to match height of adjacent table since "selected accounts" has a button-->
                      </b-col>
                    </div>
                    <div>
                      <b-form-input v-model="UnselectedSearch" placeholder="Search available accounts" class="my-1"></b-form-input>
                      <b-table :fields="fields" :items="UnselectedAccounts" striped ref="UnselectedTable" :per-page="perPage" :current-page="currentPage" :filter="UnselectedSearch" class="EnterpriseAccountTable">
                        <template slot="Selected" slot-scope="row">
                          <dx-switch type="checkbox" v-model:value="row.item.Selected" @value-changed="switchChange()"></dx-switch>
                        </template>
                      </b-table>

                    </div>
                    <div class="overflow-auto">
                      <b-pagination v-model="currentPage"
                                    :total-rows="unselectedRows"
                                    :per-page="perPage"
                                    aria-controls="my-table"></b-pagination>
                    </div>
                  </b-card>
                </b-col>
                <b-col lg="6">
                  <b-card>
                    <div class="row" slot="header">
                      <b-col class="col-sm-4"><strong>Selected Accounts</strong></b-col>
                      <b-col class="col-sm-8 text-right">
                        <b-btn class="btn btn-success" @click="removeAll">
                          <i title="Back" class="fa fa-floppy-o fa-lg text-white"></i> <strong class="text-white">
                            Remove All
                          </strong>
                        </b-btn>
                      </b-col>
                    </div>
                    <div>
                      <b-form-input v-model="SelectedSearch" placeholder="Search selected accounts" class="my-1"></b-form-input>
                      <b-table :fields="fields" :items="SelectedAccounts" striped ref="SelectedTable" :filter="SelectedSearch" class="EnterpriseAccountTable">
                        <template slot="Selected" slot-scope="row">
                          <dx-switch type="checkbox" v-model="row.item.Selected" @value-changed="switchChange()"></dx-switch>
                        </template>
                      </b-table>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </base-page-component>
</template>

<script>
  import axios from 'axios'
  import store from '@/store'
  import { basePageMixin } from '@/mixins/basePageMixin'
  import { DxTextBox } from 'devextreme-vue'
  import DxSelectBox from 'devextreme-vue/select-box'
  import { DxSwitch } from 'devextreme-vue/ui/switch'

  export default {
    components: {
      DxSwitch,
      DxTextBox,
      DxSelectBox
    },
    mixins: [basePageMixin],
    data() {
      return {
        dpConfig: {
          format: 'MM/DD/YYYY',
          useCurrent: false
        },
        role: 'User',
        account: undefined,
        partnerId: [],
        UnassignedAccounts: [],
        EnterpriseData: [],
        fields: ['AccountName', 'Selected'],
        SelectedAccounts: [],
        UnselectedAccounts: [],
        perPage: 10,
        currentPage: 1,
        EnterpriseName: '',
        UnselectedSearch: '',
        SelectedSearch: '',
        PartnerName: 'loading...'
      }
    },
    created() {
      this.role = store.state.currentRole;
      if (this.$route.params.partnerName) {
        this.PartnerName = this.$route.params.partnerName
      }
      this.fetchData()
    },
    methods: {
      switchChange() {
        var self = this
        //need this settimeout to fix error where switch of next element incorrectly flips on and appears on in screen (but not actually on)
        //using UnselectedAccounts and SelectedAccounts rather than setting the "Unassigned/Assigned" accounts to maintain the original values to be used on SaveChanges
        setTimeout(() => {
          if (!self.EnterpriseData || !self.EnterpriseData.Accounts) {
            self.UnselectedAccounts = [...self.UnassignedAccounts].filter(r => r.Selected === false)
            self.SelectedAccounts = [...self.UnassignedAccounts].filter(r => r.Selected === true)
          } else {
            self.UnselectedAccounts = [...self.UnassignedAccounts, ...self.EnterpriseData.Accounts].filter(r => r.Selected === false)
            self.SelectedAccounts = [...self.UnassignedAccounts, ...self.EnterpriseData.Accounts].filter(r => r.Selected === true)
          }
        }, 1)
      },
      removeAll() {
        this.SelectedAccounts.forEach(a => { a.Selected = false })
      },
      //Update enterprise name, delete and add accounts to the enterprise
      async saveChanges() {
        this.toggleloader(true)
        const updateEnterprise = {}
        updateEnterprise.PartnerId = this.partnerId
        updateEnterprise.Name = this.EnterpriseName

        const data = {}
        data.Item = []

        try {
          //if EnterpriseData is undefined, it's an add
          if (!this.EnterpriseData.EnterpriseId) {
            updateEnterprise.Accounts = [...this.UnassignedAccounts.filter(r => r.Selected === true)]
            data.Item.push(updateEnterprise)
            const request = JSON.parse(JSON.stringify(data))

            var response = await axios.post('/api/enterprise/addenterprisewithaccounts', request)

            // need to set enterprise Id to change form to an "edit"
            this.EnterpriseData = response.data.find(f => f.Name === this.EnterpriseName)

            // this means it couldn't find the enterprise in the response, return error
            if (!this.EnterpriseData) {
              this.HandleError('Something went wrong adding the enteprise', false)
              return
            }

            //reset unassigned accounts to only include false items
            this.UnassignedAccounts = this.UnassignedAccounts.filter(r => r.Selected === false)
            this.showNotification('Enterprise Saved')
            this.toggleloader(false)
          }
          else {
            
            updateEnterprise.EnterpriseId = this.EnterpriseData.EnterpriseId

            //add and delete accounts with changes made only in this session rather than taking all on the selected/unselected list
            updateEnterprise.Accounts = this.UnassignedAccounts.filter(r => r.Selected === true)

            if (this.EnterpriseData.Accounts) {
              updateEnterprise.Accounts = [...updateEnterprise.Accounts, ...this.EnterpriseData.Accounts.filter(r => r.Selected === false)]
            }

            data.Item.push(updateEnterprise)
            const request = JSON.parse(JSON.stringify(data))

            await axios.post('/api/enterprise/updateenterpriseaccount', request)

            var newSelected = []

            // update main array
            if (this.EnterpriseData.Accounts) {
              newSelected = [...this.UnassignedAccounts, ...this.EnterpriseData.Accounts].filter(r => r.Selected === true)
              this.UnassignedAccounts = [...this.UnassignedAccounts, ...this.EnterpriseData.Accounts].filter(r => r.Selected === false)
            }
            else {
              newSelected = this.UnassignedAccounts.filter(r => r.Selected === true)
              this.UnassignedAccounts = this.UnassignedAccounts.filter(r => r.Selected === false)
            }

            this.EnterpriseData.Accounts = newSelected
            this.toggleloader(false)
            this.showNotification('Changes Saved')
          }
        }
        catch (error) {
          this.handleError(error)
          this.toggleloader(false)
        }
      },
      //delete enterprise if no associated accounts
      async deleteEnterprise() {
        const data = {}
        data.Item = []

        if (this.EnterpriseData.Accounts && this.EnterpriseData.Accounts.length > 0) {
          this.showError('\'' + this.EnterpriseData.Name + '\' has accounts associated and cannot be deleted.', false)
          return
        }

        if (await this.$dialog.confirm("Are you sure you want to delete this enterprise?")) {
          try {
            data.Item.push(this.EnterpriseData)
            const request = JSON.parse(JSON.stringify(data))
            await axios.post('/api/enterprise/deleteenterprise', request)
            this.$router.replace({
              name: 'Enterprise',
              params: { msg: 'Enterprise successfully deleted', partnerId: this.partnerId }
            })
          }
          catch (error) {
            this.handleError(error)
          }
        }
      },
      async fetchData() {

        let self = this
        this.partnerId = this.$route.params.partnerId
        this.EnterpriseData.EnterpriseId = this.$route.params.enterpriseId

        let args = {
          enterpriseId: this.EnterpriseData.EnterpriseId,
          partnerId: this.partnerId
        }

        try {
          var response = await axios.post('/api/enterprise/getenterpriseaccount', args)

          if (response.data.length == 0)
            return

          //get unassigned accounts
          let unassignedEnt = response.data.filter(r => r.EnterpriseId === null)

          if (unassignedEnt.length > 0) {
            if (unassignedEnt[0].Accounts) {
              this.UnassignedAccounts = unassignedEnt[0].Accounts
            }
          }

          if (this.EnterpriseData.EnterpriseId != null) {
            this.EnterpriseData = response.data.filter(r => r.EnterpriseId === self.EnterpriseData.EnterpriseId)[0]
            this.EnterpriseName = this.EnterpriseData.Name
          }

          if (!this.EnterpriseData || !this.EnterpriseData.Accounts) {
            this.UnselectedAccounts = [...this.UnassignedAccounts].filter(r => r.Selected === false)
            this.SelectedAccounts = [...this.UnassignedAccounts].filter(r => r.Selected === true)
          } else {
            this.UnselectedAccounts = [...this.UnassignedAccounts, ...this.EnterpriseData.Accounts].filter(r => r.Selected === false)
            this.SelectedAccounts = [...this.UnassignedAccounts, ...this.EnterpriseData.Accounts].filter(r => r.Selected === true)
          }
        }
        catch (error) {
          this.handleError(error)
        }
        finally {
          this.toggleloader(false)
        }
      }
    },
    computed: {
      unselectedRows() {
        return this.UnselectedAccounts.length
      }
    }
  }</script>

<style>
  .EnterpriseAccountTable th:first-child {
    width: 90%;
  }

  .btn {
    min-width: 200px;
  }

  /* cannot group into comma seperated dunno why*/
  ::-webkit-input-placeholder {
    font-style: italic;
  }

  :-moz-placeholder {
    font-style: italic;
  }

  ::-moz-placeholder {
    font-style: italic;
  }

  :-ms-input-placeholder {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/views/EnterpriseDetails.vue